/**
 * 环境配置入口（H5 / RN 共用）
 *
 * 切换环境：改 USE_PROD，然后重启 dev server
 */

import * as devEnv from "./env.dev.js"
import * as prodEnv from "./env.prod.js"

/** true = 生产  false = 开发 */
const USE_PROD = true

const env = USE_PROD ? prodEnv : devEnv

export const ENV_NAME = USE_PROD ? "prod" : "dev"
export const API_URL = env.API_URL
export const WS_URL = env.WS_URL
export const WEB_URL = env.WEB_URL
export const CDN_URL = env.CDN_URL
export const JPUSH_APP_KEY_IOS = env.JPUSH_APP_KEY_IOS ?? env.JPUSH_APP_KEY
export const JPUSH_APP_KEY_ANDROID = env.JPUSH_APP_KEY_ANDROID ?? env.JPUSH_APP_KEY
export const APP_NAME = env.APP_NAME
export const REDIRECT_URL = env.REDIRECT_URL
export const ENCRYPT_KEY = env.ENCRYPT_KEY

const config = {
  ENV_NAME,
  API_URL,
  WS_URL,
  WEB_URL,
  CDN_URL,
  JPUSH_APP_KEY_IOS,
  JPUSH_APP_KEY_ANDROID,
  APP_NAME,
  REDIRECT_URL,
  ENCRYPT_KEY,
}

export default config
